import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
// import _ from 'lodash';
import { useParams } from 'react-router-dom';
// import StoryContext from '../../contexts/StoryContext';
import FiltersContext from '../../contexts/FiltersContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
// import states, { stateFIPS } from '../../modules/states';
import { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import NoDataVisual from '../NoDataVisual';
import { years } from '../../modules/years';

function ProvidersChangeSubsidies() {
  const { stateCode } = useParams();
  const { displayBy } = useContext(FiltersContext);
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({});
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    setError(null);
    setReady(false);
    const getCapacity = function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND is_subsidized=1`;
      whereClause += composeWhereClause({}, true, false); // don't use child age

      return rdsTabulate('ccdc', 'tract_licensed_capacity', {
        dims: 'wave_id',
        measure: 'capacity:SUM(cnt_provider)',
        where: whereClause,
        format: 'amcharts',
        orderby: 'wave_id',
      }, false, null); // use cache, unset wave
    };

    getCapacity().then((response) => {
      const dataItems = response.parsedBody.dataProvider;
      if (dataItems.length === 0) {
        setNoData(true);
        return;
      }
      let dataObject = {};
      dataItems.forEach((di) => {
        const label = di.wave_id === years.rdsCovidWave.toString() ? 'from' : 'to';
        const v = {};
        v[label] = di.capacity;
        dataObject = { ...dataObject, ...v };
      });
      setData(dataObject);
    })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, displayBy]);

  if (noData) {
    return <NoDataVisual />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      Prior to the outbreak of COVID-19, there were <b>{toFormattedNumber(data.from)}</b> licensed providers accepting subsidies.
      As of {years.covidToMonthYear}, there were <b>{toFormattedNumber(data.to)}</b> licensed providers accepting subsidies.
      The bar chart below compares the change in the number of providers who accept subsidies.
    </>
  );
}

export default ProvidersChangeSubsidies;
